import { render, staticRenderFns } from "./SalesReport.vue?vue&type=template&id=be2c4f9c&"
import script from "./SalesReport.vue?vue&type=script&lang=ts&"
export * from "./SalesReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports